export default __webpack_public_path__ + "media/images/select2-df43415dfa09372519f56bfadb7a3445.png";